(function(){
  var dataEl=document.getElementById('kb-data');
  if(!dataEl)return;
  var D=JSON.parse(dataEl.textContent);
  var list=document.getElementById('kb-list');
  var totalCapEl=document.getElementById('kb-total-cap');
  var totalEl=document.getElementById('kb-total');
  var saveEl=document.getElementById('kb-save');
  var addBtn=document.getElementById('kb-add');
  var msgEl=document.getElementById('kb-msg');
  var sticky=document.getElementById('kb-sticky');
  var stickyAdd=document.getElementById('kb-sticky-add');
  var stickyCap=document.getElementById('kb-sticky-cap');
  var stickyTotal=document.getElementById('kb-sticky-total');
  var stickySave=document.getElementById('kb-sticky-save');
  var AYAR={};
  try{AYAR=JSON.parse(document.getElementById('kb-ayar').textContent);}catch(e){}
  var ADD_LABEL=AYAR.addLabel||'Kombini Sepete Ekle';
  var RECO_LIMIT=AYAR.recoLimit||8;
  var sel={};

  function track(ev,params){
    try{
      var p=params||{};
      if(window.gtag){window.gtag('event',ev,p);}
      else if(window.dataLayer){var o={event:ev};for(var k in p){o[k]=p[k];}window.dataLayer.push(o);}
      if(window.fbq){window.fbq('trackCustom',ev,p);}
      if(window.Shopify&&window.Shopify.analytics&&window.Shopify.analytics.publish){window.Shopify.analytics.publish(ev,p);}
    }catch(e){}
  }

  function money(c){return '₺'+(c/100).toLocaleString('tr-TR',{minimumFractionDigits:2,maximumFractionDigits:2});}
  function esc(s){return String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/"/g,'&quot;');}

  function findVariant(p,opts){
    for(var i=0;i<p.variants.length;i++){
      var v=p.variants[i],ok=true;
      for(var j=0;j<opts.length;j++){if(v.opts[j]!==opts[j]){ok=false;break;}}
      if(ok)return v;
    }
    return null;
  }

  function valAvailable(p,oi,val){
    for(var i=0;i<p.variants.length;i++){
      var v=p.variants[i];
      if(!v.avail)continue;
      if(v.opts[oi]!==val)continue;
      var ok=true;
      for(var j=0;j<p.optNames.length;j++){
        if(j===oi)continue;
        if(sel[p.id][j]&&v.opts[j]!==sel[p.id][j]){ok=false;break;}
      }
      if(ok)return true;
    }
    return false;
  }

  function defaults(p){
    for(var i=0;i<p.variants.length;i++){if(p.variants[i].avail){return p.variants[i].opts.slice();}}
    return p.variants.length?p.variants[0].opts.slice():[];
  }

  function optionValues(p,oi){
    var vals=[];
    for(var i=0;i<p.variants.length;i++){
      var val=p.variants[i].opts[oi];
      if(vals.indexOf(val)===-1)vals.push(val);
    }
    return vals;
  }

  function render(){
    var html='';
    D.products.forEach(function(p){
      html+='<div class="kb-card" data-pid="'+p.id+'"><a href="'+p.url+'"><img src="'+(p.img||'')+'" alt="" loading="lazy"></a><div>';
      html+='<p class="kb-ptitle">'+p.title+'</p>';
      p.optNames.forEach(function(on,oi){
        html+='<div class="kb-optname">'+esc(on)+': <span class="kb-optval">'+esc(sel[p.id][oi]||'')+'</span></div><div class="kb-vals" data-oi="'+oi+'">';
        optionValues(p,oi).forEach(function(val){
          var cls='kb-val';
          if(sel[p.id][oi]===val)cls+=' sel';
          if(!valAvailable(p,oi,val))cls+=' ko';
          html+='<button type="button" class="'+cls+'" data-val="'+val.replace(/"/g,'&quot;')+'">'+val+'</button>';
        });
        html+='</div>';
      });
      var v=findVariant(p,sel[p.id]);
      if(v){
        if(D.pct>0){
          var disc=Math.round(v.price*(100-D.pct)/100);
          html+='<div class="kb-price"><span class="kb-cap">'+money(v.price)+'</span><span class="kb-final">'+money(disc)+'</span></div>';
        }else{
          html+='<div class="kb-price"><span class="kb-final">'+money(v.price)+'</span></div>';
        }
      }
      /* Tekli ekleme: minimal link; kombin indirimi UYGULANMAZ (tam fiyat) */
      var canAdd=!!(v&&v.avail);
      html+='<button type="button" class="kb-single" data-single'+(canAdd?'':' disabled')+'>Sadece bunu sepete ekle</button>';
      html+='</div></div>';
    });
    list.innerHTML=html;
    updateTotals();
  }

  function updateTotals(){
    var total=0,ok=true;
    D.products.forEach(function(p){
      var v=findVariant(p,sel[p.id]);
      if(v&&v.avail){total+=v.price;}else{ok=false;}
    });
    var capTxt='',finalTxt='',saveTxt='';
    if(D.pct>0){
      var disc=Math.round(total*(100-D.pct)/100);
      capTxt=money(total);finalTxt=money(disc);
      if(total>0)saveTxt='Kazancın: '+money(total-disc);
    }
    else{finalTxt=money(total);}
    totalCapEl.textContent=capTxt;
    totalEl.textContent=finalTxt;
    if(saveEl){saveEl.textContent=saveTxt;if(saveTxt&&ok)saveEl.removeAttribute('hidden');else saveEl.setAttribute('hidden','');}
    if(stickyCap)stickyCap.textContent=capTxt;
    if(stickyTotal)stickyTotal.textContent=finalTxt;
    if(stickySave){stickySave.textContent=saveTxt;if(saveTxt&&ok)stickySave.removeAttribute('hidden');else stickySave.setAttribute('hidden','');}
    addBtn.disabled=!ok;
    if(stickyAdd)stickyAdd.disabled=!ok;
    msgEl.textContent=ok?'':'Bazı ürünlerde seçili beden stokta yok.';
    syncSticky();
  }

  function syncSticky(){
    if(!sticky)return;
    var vh=window.innerHeight||document.documentElement.clientHeight||0;
    if(!vh)return;
    var r=addBtn.getBoundingClientRect();
    var mainVisible=r.top<(vh-40)&&r.bottom>0;
    if(mainVisible)sticky.setAttribute('hidden','');
    else sticky.removeAttribute('hidden');
  }

  D.products.forEach(function(p){sel[p.id]=defaults(p);});
  render();
  track('kombin_view',{kombin:D.h});

  window.addEventListener('scroll',syncSticky,{passive:true});
  window.addEventListener('resize',syncSticky);
  syncSticky();

  function singleAdd(card,btn){
    var pid=card.getAttribute('data-pid');
    var p=null;
    for(var i=0;i<D.products.length;i++){if(String(D.products[i].id)===String(pid)){p=D.products[i];break;}}
    if(!p)return;
    var v=findVariant(p,sel[p.id]);
    if(!v||!v.avail)return;
    var old=btn.textContent;
    btn.disabled=true;btn.textContent='Ekleniyor...';
    track('kombin_single_add_to_cart',{kombin:D.h,product_id:p.id,value:v.price/100,currency:'TRY'});
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:v.id,quantity:1}]})})
      .then(function(r){if(!r.ok)throw new Error('cart');return r.json();})
      .then(function(){
        btn.textContent='Eklendi ✓';
        /* Kombin indirimi BILEREK uygulanmiyor - tekli eklemede indirim yok */
        if(!(window.PAKombinCart&&window.PAKombinCart.refreshAndShow())){
          window.location.href='/cart';
          return;
        }
        setTimeout(function(){btn.disabled=false;btn.textContent=old;},2200);
      })
      .catch(function(){
        btn.disabled=false;btn.textContent=old;
        msgEl.textContent='Bir hata oluştu, tekrar deneyin.';
      });
  }

  list.addEventListener('click',function(ev){
    var single=ev.target.closest('[data-single]');
    if(single){singleAdd(single.closest('.kb-card'),single);return;}
    var btn=ev.target.closest('.kb-val');
    if(!btn)return;
    var card=btn.closest('.kb-card');
    var pid=card.getAttribute('data-pid');
    var oi=parseInt(btn.parentElement.getAttribute('data-oi'),10);
    sel[pid][oi]=btn.getAttribute('data-val');
    render();
  });

  function resetBtns(){
    addBtn.disabled=false;addBtn.textContent=ADD_LABEL;
    if(stickyAdd){stickyAdd.disabled=false;stickyAdd.textContent=ADD_LABEL;}
  }

  function doAdd(){
    var items=[],ok=true,total=0;
    D.products.forEach(function(p){
      var v=findVariant(p,sel[p.id]);
      if(v&&v.avail){items.push({id:v.id,quantity:1,properties:{_kombin:D.h,_paket:D.h}});total+=v.price;}else{ok=false;}
    });
    if(!ok||!items.length){msgEl.textContent='Lütfen tüm ürünler için stokta olan bir seçim yapın.';return;}
    addBtn.disabled=true;addBtn.textContent='Ekleniyor...';
    if(stickyAdd){stickyAdd.disabled=true;stickyAdd.textContent='Ekleniyor...';}
    track('kombin_add_to_cart',{kombin:D.h,value:Math.round(total*(100-D.pct)/100)/100,currency:'TRY'});
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})})
      .then(function(r){if(!r.ok)throw new Error('cart');return r.json();})
      .then(function(){
        resetBtns();
        /* sayfada kal, drawer'i ac; tazelenecek satir yoksa /cart'a dus */
        if(!(window.PAKombinCart&&window.PAKombinCart.refreshAndShow())){
          window.location.href='/cart';
        }
      })
      .catch(function(){
        resetBtns();
        msgEl.textContent='Bir hata oluştu, tekrar deneyin.';
      });
  }

  addBtn.addEventListener('click',doAdd);
  if(stickyAdd)stickyAdd.addEventListener('click',doAdd);

  var recoWrap=document.getElementById('kb-reco'),recoStrip=document.getElementById('kb-reco-strip');
  if(recoWrap&&recoStrip&&D.products.length){
    var cents=function(v){
      if(typeof v==='number')return v;
      var n=parseFloat(v);
      return isNaN(n)?0:Math.round(n*100);
    };
    var card=function(p){
      var t=String(p.title||''),name=t,color='',ix=t.indexOf(' | ');
      if(ix>-1){name=t.slice(0,ix);color=t.slice(ix+3);}
      var img=p.featured_image||(p.images&&p.images[0])||'';
      var pr=cents(p.price),cmp=p.compare_at_price?cents(p.compare_at_price):0;
      return '<a class="kb-reco-item" href="'+esc(p.url)+'" data-reco="'+esc(p.handle)+'">'+
        '<img src="'+esc(img)+'" alt="'+esc(t)+'" loading="lazy">'+
        '<p class="kb-reco-name">'+esc(name)+'</p>'+
        (color?'<p class="kb-reco-color">'+esc(color)+'</p>':'')+
        '<p class="kb-reco-price">'+(cmp>pr?'<s>'+money(cmp)+'</s>':'')+money(pr)+'</p>'+
      '</a>';
    };
    fetch('/recommendations/products.json?product_id='+D.products[0].id+'&limit='+RECO_LIMIT+'&intent=related',{headers:{'Accept':'application/json'}})
      .then(function(r){return r.ok?r.json():{products:[]};})
      .then(function(d){
        var inCombo={};
        D.products.forEach(function(p){inCombo[p.id]=1;});
        var out=(d.products||[]).filter(function(p){return !inCombo[p.id];});
        if(!out.length)return;
        recoStrip.innerHTML=out.map(card).join('');
        recoWrap.removeAttribute('hidden');
        track('kombin_reco_view',{kombin:D.h,count:out.length});
        syncSticky();
      }).catch(function(){});
    recoStrip.addEventListener('click',function(ev){
      var a=ev.target.closest('[data-reco]');
      if(a)track('kombin_reco_click',{kombin:D.h,handle:a.getAttribute('data-reco')});
    });
  }
})();
